import { InputMaskCurrency, InputMaskDateTime, InputMaskNumeric, InputMaskPattern, } from "survey-core";
import { MaskType } from "../../../types/forms";
export var createInputMaskInstance = function (element) {
    var maskType = element.maskType, maskSettings = element.maskSettings;
    if (!maskType) {
        return null;
    }
    var mask;
    switch (maskType) {
        case MaskType.PATTERN:
            mask = new InputMaskPattern();
            break;
        case MaskType.NUMERIC:
            mask = new InputMaskNumeric();
            break;
        case MaskType.CURRENCY:
            mask = new InputMaskCurrency();
            break;
        case MaskType.DATETIME:
            mask = new InputMaskDateTime();
            break;
        default:
            return null;
    }
    if (maskSettings) {
        mask.setData(maskSettings);
    }
    return mask;
};
export var shouldSaveMaskedValue = function (element) { var _a; return Boolean((_a = element.maskSettings) === null || _a === void 0 ? void 0 : _a.saveMaskedValue); };
